import { call, select, takeEvery } from 'redux-saga/effects';
import { ARRANGE_BENCH, ARRANGE_HAND } from './constants';
import gameTurnService from '../services/gameTurn';
import { handleUpdateGame } from '../ActiveGame/sagas';
import { selectActiveGame } from '../ActiveGame/selectors';

function* arrangeTask(action) {
  const gameId = (yield select(selectActiveGame)).get('id');
  const { from, to } = action.payload;
  const send = action.type === ARRANGE_BENCH ? gameTurnService.arrangeBench : gameTurnService.arrangeHand;
  const game = yield call(send, gameId, from, to);
  yield call(handleUpdateGame, game);
}

function* arrangeWatcher() {
  yield takeEvery([ARRANGE_BENCH, ARRANGE_HAND], arrangeTask);
}

export default [
  arrangeWatcher,
];
